import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { SelectivePreloadingStrategy } from './selective-preloading.strategy';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  provideClientHydration,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { cacheInterceptor } from './interceptors/cache.interceptor';
import { authErrorInterceptor } from './interceptors/auth-error.interceptor';
import { MbErrorHandler } from './core/mb-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: MbErrorHandler },
    provideHttpClient(
      withFetch(), // ✅ use Fetch API for better performance
      withInterceptors([authErrorInterceptor, cacheInterceptor]) // ✅ Add auth error handling and HTTP caching
    ),
    provideRouter(
      routes,
      withPreloading(SelectivePreloadingStrategy),
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideZoneChangeDetection({ 
      eventCoalescing: true, // ✅ Coalesce multiple events into single change detection cycle
      runCoalescing: true // ✅ Enable run coalescing
    }),
    // Hydration + HTTP transfer cache.
    // Do not use withIncrementalHydration() (white seller panel) or withEventReplay()
    // (production /sellar-login kept jsaction="click:;" on Continue forever, so the
    // password step never opened).
    ...(environment.ssr !== false
      ? [
          provideClientHydration(
            withHttpTransferCacheOptions({
              includePostRequests: false,
              includeRequestsWithAuthHeaders: false,
            }),
          ),
        ]
      : []),
  ],
};
